import React from 'react';
import PropTypes from 'prop-types';

import { Card, Popper, MenuItem, Typography } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import Scrollbar from 'src/components/scrollbar/Scrollbar';

function SubFilterPopper({
  subFilterPopover,
  handleCloseSubFilter,
  setFilterBy,
  setSearchBy,
  setSelectedFilter,
  setFilterName,
  handleCloseFilter,
  setPage,
  departmentData,
}) {
  const { isSmallScreen } = useResponsiveScreen();

  return (
    <Popper
      open={Boolean(subFilterPopover.department)}
      anchorEl={subFilterPopover.department}
      placement="left-start"
      onClose={handleCloseSubFilter}
    >
      <Card
        sx={{
          p: 1,
          minwidth: 140,
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
            boxShadow: '0.5px 0.5px 2 px',
          },
        }}
      >
        <Scrollbar sx={{ maxHeight: 200, overflowY: 'auto' }}>
          {departmentData.map((department) => (
            <MenuItem
              key={department.id}
              onClick={() => {
                setFilterBy('department.name');
                setSearchBy('byDepartment');
                setSelectedFilter('department');
                setFilterName(department.name);
                handleCloseFilter();
                handleCloseSubFilter();
                setPage(0);
              }}
              onTouchStart={() => {
                setFilterBy('department.name');
                setSearchBy('byDepartment');
                setSelectedFilter('department');
                setFilterName(department.name);
                handleCloseFilter();
                handleCloseSubFilter();
                setPage(0);
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: isSmallScreen && '0.7rem',
                }}
              >
                {department.name}
              </Typography>
            </MenuItem>
          ))}
        </Scrollbar>
      </Card>
    </Popper>
  );
}

SubFilterPopper.propTypes = {
  subFilterPopover: PropTypes.object,
  handleCloseSubFilter: PropTypes.func,
  setFilterBy: PropTypes.func,
  setSearchBy: PropTypes.func,
  setSelectedFilter: PropTypes.func,
  setFilterName: PropTypes.func,
  handleCloseFilter: PropTypes.func,
  setPage: PropTypes.func,
  departmentData: PropTypes.array,
};

export default SubFilterPopper;
